import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchPerformanceResultsQueryVariables = SchemaTypes.Exact<{
  pagination?: SchemaTypes.InputMaybe<SchemaTypes.Pagination>;
  filter?: SchemaTypes.InputMaybe<SchemaTypes.PerformanceResultFilterRule>;
}>;


export type FetchPerformanceResultsQuery = (
  { __typename: 'Query' }
  & { performanceResults: (
    { __typename: 'PaginatedPerformanceResult' }
    & Pick<SchemaTypes.PaginatedPerformanceResult, 'count'>
    & { items: Array<(
      { __typename: 'PerformanceResult' }
      & PerformanceResultListItemDataFragment
    )> }
  ) }
);

export type PerformanceResultListItemDataFragment = (
  { __typename: 'PerformanceResult' }
  & Pick<SchemaTypes.PerformanceResult, 'id' | 'companyId' | 'userId' | 'isTiedToAssessmentRun' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedBy' | 'updatedAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: (
    { __typename: 'BmpResult' }
    & PerformanceResultBmpResultDataFragment
  ) | (
    { __typename: 'FinSwimResult' }
    & PerformanceResultFinSwimResultDataFragment
  ) | (
    { __typename: 'IpptResult' }
    & PerformanceResultIpptResultDataFragment
  ) | (
    { __typename: 'March20kmResult' }
    & PerformanceResultMarch20kmResultDataFragment
  ) | (
    { __typename: 'SocResult' }
    & PerformanceResultSocResultDataFragment
  ) | (
    { __typename: 'WeightResult' }
    & PerformanceResultWeightResultDataFragment
  ), updatedByUser?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )> }
);

export type PerformanceResultWeightResultDataFragment = (
  { __typename: 'WeightResult' }
  & Pick<SchemaTypes.WeightResult, 'weightKg'>
);

export type PerformanceResultIpptResultDataFragment = (
  { __typename: 'IpptResult' }
  & Pick<SchemaTypes.IpptResult, 'pushUps' | 'sitUps' | 'runTimeSec' | 'points' | 'pullUps' | 'award'>
);

export type PerformanceResultSocResultDataFragment = (
  { __typename: 'SocResult' }
  & Pick<SchemaTypes.SocResult, 'timingSec' | 'result'>
);

export type PerformanceResultMarch20kmResultDataFragment = (
  { __typename: 'March20kmResult' }
  & Pick<SchemaTypes.March20kmResult, 'timingSec' | 'result'>
);

export type PerformanceResultFinSwimResultDataFragment = (
  { __typename: 'FinSwimResult' }
  & Pick<SchemaTypes.FinSwimResult, 'timingSec'>
);

export type PerformanceResultBmpResultDataFragment = (
  { __typename: 'BmpResult' }
  & Pick<SchemaTypes.BmpResult, 'percentage'>
);

export type DeletePerformanceResultMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  companyId: SchemaTypes.Scalars['ObjectID']['input'];
}>;


export type DeletePerformanceResultMutation = (
  { __typename: 'Mutation' }
  & { deletePerformanceResult: (
    { __typename: 'DeletePerformanceResultSuccessfulResponse' }
    & Pick<SchemaTypes.DeletePerformanceResultSuccessfulResponse, 'success' | 'deletedId'>
  ) | (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) }
);

export const PerformanceResultWeightResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultWeightResultData on WeightResult {
  weightKg
}
    `;
export const PerformanceResultIpptResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultIpptResultData on IpptResult {
  pushUps
  sitUps
  runTimeSec
  points
  pullUps
  award
}
    `;
export const PerformanceResultSocResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultSocResultData on SocResult {
  timingSec
  result
}
    `;
export const PerformanceResultMarch20kmResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultMarch20kmResultData on March20kmResult {
  timingSec
  result
}
    `;
export const PerformanceResultFinSwimResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultFinSwimResultData on FinSwimResult {
  timingSec
}
    `;
export const PerformanceResultBmpResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultBmpResultData on BmpResult {
  percentage
}
    `;
export const PerformanceResultListItemDataFragmentDoc = /*#__PURE__*/ gql`
    fragment PerformanceResultListItemData on PerformanceResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  isTiedToAssessmentRun
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on WeightResult {
      ...PerformanceResultWeightResultData
    }
    ... on IpptResult {
      ...PerformanceResultIpptResultData
    }
    ... on SocResult {
      ...PerformanceResultSocResultData
    }
    ... on March20kmResult {
      ...PerformanceResultMarch20kmResultData
    }
    ... on FinSwimResult {
      ...PerformanceResultFinSwimResultData
    }
    ... on BmpResult {
      ...PerformanceResultBmpResultData
    }
  }
  createdAt
  completedAt
  updatedBy
  updatedByUser {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  updatedAt
}
    `;
export const FetchPerformanceResultsDocument = /*#__PURE__*/ gql`
    query FetchPerformanceResults($pagination: Pagination, $filter: PerformanceResultFilterRule) {
  performanceResults(pagination: $pagination, filter: $filter) {
    count
    items {
      ...PerformanceResultListItemData
    }
  }
}
    ${PerformanceResultListItemDataFragmentDoc}
${PerformanceResultWeightResultDataFragmentDoc}
${PerformanceResultIpptResultDataFragmentDoc}
${PerformanceResultSocResultDataFragmentDoc}
${PerformanceResultMarch20kmResultDataFragmentDoc}
${PerformanceResultFinSwimResultDataFragmentDoc}
${PerformanceResultBmpResultDataFragmentDoc}`;

/**
 * __useFetchPerformanceResultsQuery__
 *
 * To run a query within a React component, call `useFetchPerformanceResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPerformanceResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPerformanceResultsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchPerformanceResultsQuery(baseOptions?: Apollo.QueryHookOptions<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>(FetchPerformanceResultsDocument, options);
      }
export function useFetchPerformanceResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>(FetchPerformanceResultsDocument, options);
        }
// @ts-ignore
export function useFetchPerformanceResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>;
export function useFetchPerformanceResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FetchPerformanceResultsQuery | undefined, FetchPerformanceResultsQueryVariables>;
export function useFetchPerformanceResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>(FetchPerformanceResultsDocument, options);
        }
export type FetchPerformanceResultsQueryHookResult = ReturnType<typeof useFetchPerformanceResultsQuery>;
export type FetchPerformanceResultsLazyQueryHookResult = ReturnType<typeof useFetchPerformanceResultsLazyQuery>;
export type FetchPerformanceResultsSuspenseQueryHookResult = ReturnType<typeof useFetchPerformanceResultsSuspenseQuery>;
export type FetchPerformanceResultsQueryResult = Apollo.QueryResult<FetchPerformanceResultsQuery, FetchPerformanceResultsQueryVariables>;
export const DeletePerformanceResultDocument = /*#__PURE__*/ gql`
    mutation DeletePerformanceResult($id: ObjectID!, $companyId: ObjectID!) {
  deletePerformanceResult(id: $id, companyId: $companyId) {
    __typename
    ... on DeletePerformanceResultSuccessfulResponse {
      success
      deletedId
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    `;
export type DeletePerformanceResultMutationFn = Apollo.MutationFunction<DeletePerformanceResultMutation, DeletePerformanceResultMutationVariables>;

/**
 * __useDeletePerformanceResultMutation__
 *
 * To run a mutation, you first call `useDeletePerformanceResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerformanceResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerformanceResultMutation, { data, loading, error }] = useDeletePerformanceResultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useDeletePerformanceResultMutation(baseOptions?: Apollo.MutationHookOptions<DeletePerformanceResultMutation, DeletePerformanceResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePerformanceResultMutation, DeletePerformanceResultMutationVariables>(DeletePerformanceResultDocument, options);
      }
export type DeletePerformanceResultMutationHookResult = ReturnType<typeof useDeletePerformanceResultMutation>;
export type DeletePerformanceResultMutationResult = Apollo.MutationResult<DeletePerformanceResultMutation>;
export type DeletePerformanceResultMutationOptions = Apollo.BaseMutationOptions<DeletePerformanceResultMutation, DeletePerformanceResultMutationVariables>;